//! This file is modified by the island-hydration-plugin for esbuild
import { hydrateIslands } from "@renderer/core/client";
import * as pageIslands from "../.././dist/tsup/chip/islands.jsx";
import * as templateIslands from "@framework/templates/channelizer-template/chip/islands";
import { type PageContext } from '@renderer/core';

import '@framework/templates/channelizer-template/chip/style.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function render(pageContext: PageContext): void {
  hydrateIslands(pageContext.islands, { ...pageIslands, ...templateIslands,  });
  // some hydration code will be injected here by the framework
}

export { render };